/**
 * Copy the current filtered view, for the person standing at the counter.
 *
 * §9④: "Staff will send customers links — here are the 6 mm comfort-fit bands in 14K —
 * and that is worth more at a counter than any sort order." The URLs have been shareable
 * since the %20 fix; what was missing was a way to GET one without selecting the address
 * bar on a phone, which is what somebody standing beside a customer is holding.
 *
 * 🔴 IT COPIES location.href AND DOES NOT REBUILD THE URL. Reconstructing it from the
 * applied filters would be a second implementation of rules the rail already owns — and
 * those rules are not obvious: a space must be %20 and never `+`, because Shopify's own
 * cookie-bootstrap 302 reads a bare plus as a literal plus and drops the filter in
 * silence. The address bar already holds the answer that works.
 *
 * TWO WAYS TO COPY, because the modern one is not always there. navigator.clipboard needs
 * a secure context and is absent or refused in several in-app browsers — the ones staff
 * actually use when a link arrives in a message. The execCommand fallback is deprecated
 * and works in exactly those places.
 *
 * ⚠️ AND IT SAYS SO WHEN IT FAILS. A copy button that silently does nothing is worse than
 * no button: the person believes they have the link, sends nothing, and finds out from the
 * customer. On failure it selects the URL in a prompt so there is still a way through.
 */
(() => {
  const buttons = document.querySelectorAll('[data-djh-copy-link]');
  if (!buttons.length) return;

  const legacyCopy = (text) => {
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (_err) {
      ok = false;
    }
    field.remove();
    return ok;
  };

  buttons.forEach((button) => {
    const original = button.textContent;
    button.addEventListener('click', async () => {
      const url = window.location.href;
      let ok = false;

      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(url);
          ok = true;
        } catch (_err) {
          ok = false;
        }
      }
      if (!ok) ok = legacyCopy(url);

      if (ok) {
        button.textContent = button.dataset.copied || 'Copied';
        button.classList.add('is-copied');
        window.setTimeout(() => {
          button.textContent = original;
          button.classList.remove('is-copied');
        }, 2000);
        return;
      }

      // Both paths refused. Hand the URL over rather than pretending it is on the
      // clipboard — the whole point of the control is that somebody is about to send it.
      window.prompt(button.dataset.copied || 'Copy this link', url);
    });
  });
})();
